import { API_V1_URL } from './config';

type LeadResponse = {
  campaign: string;
  campaign_uuid: string;
  email: string;
  name: string | null;
  phone: string | null;
  sender: string;
  processed: boolean;
};

export async function fetchLead(
  uuid: string
): Promise<{ ok: true; body: LeadResponse } | { ok: false; body: null }> {
  const response = await fetch(`${API_V1_URL}leads/${uuid}`);
  if (response.ok) {
    return {
      ok: true,
      body: (await response.json()) as LeadResponse,
    };
  }
  return {
    ok: false,
    body: null,
  };
}
